import { Button, Text } from "components/commons";
import styles from "./key-account-list.module.scss";
import { dateTimeFormat, formatAmount } from "utils";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { prettifyKeyPaymentMethod } from "utils/pretty.utils";

export const mapDataToList = ({ keyAccountCollections, onClickView }) => {
  const {
    keyAccountCollectionId,
    shift,
    amount,
    keyAccountName,
    paymentMethod,
    siNumber,
    dateTime,
  } = keyAccountCollections;

  return {
    collectionId: (
      <>
        <Text className={styles}>{keyAccountCollectionId ?? ""}</Text>
      </>
    ),
    shiftDate: (
      <>
        <Text className={styles.td}>{`${dateTimeFormat(shift?.startShift) ?? ""} -`}</Text>
        <Text className={styles.td}>{`${dateTimeFormat(shift?.endShift) ?? ""}`}</Text>
      </>
    ),
    collectionDateAndTime: (
      <>
        <Text className={styles.td}>{dateTimeFormat(dateTime) ?? "-"}</Text>
      </>
    ),
    amount: (
      <>
        <Text className={styles.td}>{formatAmount(amount) ?? "-"}</Text>
      </>
    ),
    siNumSoa: (
      <>
        <Text className={styles.td}>{siNumber ?? "-"}</Text>
      </>
    ),
    keyAccountName: (
      <>
        <Text className={styles.td}>{keyAccountName ?? "-"}</Text>
      </>
    ),
    paymentMethod: (
      <>
        <Text className={styles.td}>{prettifyKeyPaymentMethod(paymentMethod) ?? "-"}</Text>
      </>
    ),
    action: (
      <Button
        style={{ textDecoration: "none" }}
        link
        onClick={() => onClickView?.(keyAccountCollectionId)}
      >
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>View</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { paymentMethod, ...fs } = filterState;

  return {
    ...fs,
    paymentMethod: !paymentMethod.isSelectedAll ? paymentMethod.value.join(",") : undefined,
  };
};
